module.exports = __webpack_public_path__ + "static/media/travel-visa@2x.f574845a.png";